var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewDetail',{directives:[{name:"show",rawName:"v-show",value:(_vm.job),expression:"job"}],attrs:{"header":"ข้อมูลการทำงาน","detail":_vm.scheduleDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }